import { isEmpty } from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';

export const loadPageFeedsFactory = (cid, aid) => ({ searchFilter = '', top }) => {
  const orderby = { Name: 1 };
  const filter = {
    where: [
      ...!isEmpty(searchFilter) ?
        [`contains(tolower(Name), '${searchFilter.toLocaleLowerCase().replace(/'/g, "''")}')`] :
        [],

      ["FeedCategories/any(c:c eq Enum.FeedCategory'PageFeed')"],
    ].join(' and '),
  };
  return edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Feeds
    .get({
      top,
      orderby,
      filter,
    })
    .toPromise()
    .then(({ value }) => value.map(feed => ({
      key: feed.Id,
      text: feed.Name,
      number: feed.FeedItemCount,
    })));
};

export const loadAssociatedPageFeedsFactory = (cid, aid, campaignId) => () =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .FeedAssociations
    .get({
      top: 2147483647, // max Int32
    })
    .toPromise()
    .then(({ value }) => value.map(feedAssociation => ({
      key: feedAssociation.FeedId,
      text: feedAssociation.FeedName,
    })));
